import './loader.scss';

const Loader = ({ height, decimal = 'vh', color }) => {
	const style = {
		...(color && { color }),
		...(height && {
			height: `${height}${decimal}`,
			minHeight: `${height}${decimal}`,
		}),
	};
	return (
		<div
			className="loader-wrapper"
			style={style}
		>
			<div className="lds-heart">
				<div></div>
			</div>
		</div>
	);
};

export default Loader;
